import React, { useContext, useState, useEffect } from "react";
import { ButtonBase, PickerSelectSimple } from "@reusejs/react";
import FilterSvg from "../Icons/FilterSvg";
import SearchSvg from "../Icons/SearchSvg";
import {
  payloadToUrl,
  urlToPayload,
  Context,
  getAllProperties,
} from "services";
import AdvanceSearchComponent from "./AdvanceSearchComponent";
import { useRouter } from "next/router";
import SearchModal from "./SearchModal";

export interface SearchProps {
  propertyType: boolean;
  assetType?: any;
  widthClass: any;
  propertiesFacetsWithoutFilter: any;
  urlData: any;
  propertiesList: any;
}

export default function SearchComponent(props: SearchProps) {
  const router = useRouter();
  const [open, setOpen] = useState(false);
  const { searchForm }: any = useContext(Context);
  const [filterObject, setFilterObject] = useState<any>();
  const [propertiesFacets, setPropertiesFacets] = useState<any>();
  const [ready, setReady] = useState<boolean>(false);
  const [refreshAssetList, setRefreshAssetList] = useState<any>();
  const [refreshSubAssetList, setRefreshSubAssetList] = useState<any>();
  const [refreshStateList, setRefreshStateList] = useState<any>();
  const [refreshCityList, setRefreshCityList] = useState<any>();

  useEffect(() => {
    if (props?.propertiesList !== undefined) {
      handleGetPropertiesResults();
    }
  }, [props?.propertiesList]);

  const handleGenerateFacets = (currentFilterPayloadList: any) => {
    const facetObject: any = {};
    const bank: any = [];
    const state: any = [];
    const city: any = [];
    const asset: any = [];
    const sub_asset_type: any = [];
    if (currentFilterPayloadList) {
      currentFilterPayloadList?.map((currentFilterPayload: any, index: any) => {
        currentFilterPayload?.facet_counts?.map((value: any) => {
          const countValuesList = value.counts;
          const fieldName = value.field_name;

          switch (fieldName) {
            case "dump.bank.bank_name":
            case "dump.bank.bank_slug":
              countValuesList.map((value: any) => {
                const currentBankObject = {
                  name: value.parent.bank_name,
                  uuid: value.parent.bank_uuid,
                  slug: value.parent.bank_slug,
                };
                const isBankObjectPreset = bank.find(
                  (bankObject: any) =>
                    bankObject.uuid === currentBankObject.uuid
                );
                if (isBankObjectPreset === undefined)
                  bank.push(currentBankObject);
              });

              break;

            case "dump.location.state_name":
            case "dump.location.state_slug":
              if (index !== 0) {
                countValuesList.map((value: any) => {
                  const currentStateObject = {
                    name: value.parent.state_name,
                    uuid: value.parent.state_uuid,
                    slug: value.parent.state_slug,
                  };
                  const isStateObjectPreset = state.find((stateObject: any) => {
                    return stateObject.uuid === currentStateObject.uuid;
                  });
                  if (isStateObjectPreset === undefined)
                    state.push(currentStateObject);
                });
              }
              break;

            case "dump.location.city_name":
            case "dump.location.city_slug":
              if (index !== 0) {
                countValuesList.map((value: any) => {
                  const currentCityObject = {
                    name: value.parent.city_name,
                    uuid: value.parent.city_uuid,
                    slug: value.parent.city_slug,
                  };
                  const isCityObjectPreset = city.find(
                    (cityObject: any) =>
                      cityObject.uuid === currentCityObject.uuid
                  );
                  if (isCityObjectPreset === undefined)
                    city.push(currentCityObject);
                });
              }
              break;
            case "dump.asset.asset_type_name":
            case "dump.asset.asset_type_slug":
              if (index !== 0) {
                countValuesList.map((value: any) => {
                  const currentAssetObject = {
                    uuid: value.parent.asset_type_uuid,
                    name: value.parent.asset_type_name,
                    slug: value.parent.asset_type_slug,
                  };
                  // console.log(currentAssetObject)
                  const isAssetObjectPresent = asset.find(
                    (assetObject: any) => {
                      return assetObject.uuid === currentAssetObject.uuid;
                    }
                  );
                  if (isAssetObjectPresent === undefined) {
                    asset.push(currentAssetObject);
                  }
                  const currentSubAssetObject = {
                    uuid: value.parent.sub_asset_type_uuid,
                    name: value.parent.sub_asset_type_name,
                    slug: value.parent.sub_asset_type_slug,
                  };
                  const isSubAssetObjectPresent = sub_asset_type.find(
                    (subAssetObject: any) => {
                      return subAssetObject.uuid === currentSubAssetObject.uuid;
                    }
                  );
                  if (isSubAssetObjectPresent === undefined) {
                    sub_asset_type.push(currentSubAssetObject);
                  }
                });
              }
              break;
            case "dump.asset.sub_asset_type_name":
            case "dump.asset.sub_asset_type_slug":
              if (index !== 0) {
                countValuesList.map((value: any) => {
                  const currentSubAssetsObject: any = {
                    uuid: value.parent.sub_asset_type_uuid,
                    name: value.parent.sub_asset_type_name,
                    slug: value.parent.sub_asset_type_slug,
                  };
                  const isSubAssetsObjectPresent = sub_asset_type.find(
                    (subAssetObject: any) => {
                      return (
                        subAssetObject.uuid === currentSubAssetsObject.uuid
                      );
                    }
                  );
                  if (isSubAssetsObjectPresent === undefined) {
                    sub_asset_type.push(currentSubAssetsObject);
                  }
                });
              }
              break;
            default:
              break;
          }
        });
        facetObject.bank = bank;
        facetObject.state = state;
        facetObject.city = city;
        facetObject.asset = asset;
        facetObject.sub_asset_type = sub_asset_type;
      });
    }

    return facetObject;
  };
  const handleGetPropertiesResults = async () => {
    const facetObject = handleGenerateFacets(props?.propertiesList);
    setPropertiesFacets(facetObject);
  };

  const generateDropdownValues = async (formElement: any, query: any) => {
    let filteredData;
    switch (formElement) {
      case "asset_type":
        filteredData = propertiesFacets?.asset?.map((item: any) => {
          return { value: item.slug, label: item.name };
        });

        break;
      case "sub_asset_type":
        filteredData = propertiesFacets?.sub_asset_type?.map((item: any) => {
          return { value: item.slug, label: item.name };
        });

        break;
      case "state":
        filteredData = propertiesFacets?.state?.map((item: any) => {
          return { value: item.slug, label: item.name };
        });

        break;
      case "city":
        filteredData = propertiesFacets?.city?.map((item: any) => {
          return { value: item.slug, label: item.name };
        });

        break;
      case "institutes":
        filteredData = propertiesFacets?.bank?.map((item: any) => {
          return { value: item.slug, label: item.name };
        });
        break;
      default:
        break;
    }

    if (query) {
      const filterOptions = filteredData.filter(
        (option: any) =>
          option.label.toLowerCase().indexOf(query.toLowerCase()) > -1
      );

      return filterOptions;
    } else {
      return filteredData;
    }
  };

  const handleAssetOnChange = async (value: any) => {
    searchForm.setField("asset_type", value);
    searchForm.setField("sub_asset_type", "");
  };

  const handleSubAssetOnChange = (value: any) => {
    searchForm.setField("sub_asset_type", value);
  };

  const handleStateOnChange = (value: any) => {
    searchForm.setField("state", value);
    searchForm.setField("city", "");
  };

  const handleCityOnChange = (value: any) => {
    searchForm.setField("city", value);
  };
  useEffect(() => {
    handleRefreshElement();
  }, [propertiesFacets]);

  const handleRefreshElement = () => {
    setRefreshAssetList(new Date().getTime());
    setRefreshSubAssetList(new Date().getTime());
    setRefreshStateList(new Date().getTime());
    setRefreshCityList(new Date().getTime());
  };

  useEffect(() => {
    if (props.assetType) {
      setReady(false);
      searchForm.setField("sub_asset_type", "");
      searchForm.setField("state", "");
      setReady(true);
    }
  }, []);

  const handleSubmit = () => {
    payloadToUrl(router, searchForm.value);
  };

  useEffect(() => {
    if (router.asPath.match("auction-properties")) {
      payloadToUrl(router, searchForm.value);
    }
  }, [
    searchForm.value.asset_type,
    searchForm.value.sub_asset_type,
    searchForm.value.state,
    searchForm.value.city,
    searchForm.value.reserve_price,
    searchForm.value.institutes,
    searchForm.value.filter_by,
    searchForm.value.sort_by,
  ]);

  const fieldWrapperClass = props.widthClass
    ? `${props.widthClass} lg:mr-4`
    : "w-64 mt-4 lg:mt-0 lg:mr-4";

  return ready ? (
    <div className="flex lg:mt-[initial] flex-col lg:flex-row justify-center items-center w-full lg:items-end px-4 space-y-4 lg:space-y-0">
      {router.pathname !== "/" && props.propertyType && (
        <div className={fieldWrapperClass} id="assetType">
          <PickerSelectSimple
            refresh={refreshAssetList}
            dataSource={async (c) => {
              return generateDropdownValues("asset_type", c);
            }}
            defaultSelected={
              searchForm.getField("asset_type") !== ""
                ? [searchForm.getField("asset_type")]
                : []
            }
            labelBaseProps={{
              label: "Property type",
            }}
            onChange={(value) => {
              handleAssetOnChange(value);
            }}
            valueKey="value"
            multiple={false}
            enableClear={false}
            enableClose={false}
            enableSearch={true}
            onOpenClose={(value) => {
              if (value) {
                document.getElementById("assetType")?.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                  inline: "nearest",
                });
              }
            }}
          />
        </div>
      )}

      <div className={fieldWrapperClass} id="assetSubType">
        <PickerSelectSimple
          refresh={refreshSubAssetList}
          dataSource={async (c: any) => {
            return generateDropdownValues("sub_asset_type", c);
          }}
          defaultSelected={
            searchForm.getField("sub_asset_type") !== ""
              ? [searchForm.getField("sub_asset_type")]
              : []
          }
          labelBaseProps={{
            label: "Asset sub type",
          }}
          onChange={(value) => {
            handleSubAssetOnChange(value);
          }}
          defaultString="Select property type"
          valueKey="value"
          multiple={false}
          enableClear={false}
          enableClose={false}
          enableSearch={true}
          disabled={searchForm.value.asset_type ? false : true}
          onOpenClose={(value) => {
            if (value) {
              document.getElementById("assetSubType")?.scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "nearest",
              });
            }
          }}
        />
      </div>
      <div className={fieldWrapperClass} id="state">
        <PickerSelectSimple
          refresh={refreshStateList}
          dataSource={async (c) => {
            return generateDropdownValues("state", c);
          }}
          defaultSelected={
            searchForm.getField("state") !== ""
              ? [searchForm.getField("state")]
              : []
          }
          labelBaseProps={{
            label: "Location",
          }}
          onChange={(value) => {
            handleStateOnChange(value);
          }}
          defaultString="Select State"
          valueKey="value"
          multiple={false}
          enableClear={false}
          enableClose={false}
          enableSearch={true}
          onOpenClose={(value) => {
            if (value) {
              document.getElementById("state")?.scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "nearest",
              });
            }
          }}
        />
      </div>
      <div className={fieldWrapperClass} id="city">
        <PickerSelectSimple
          refresh={refreshCityList}
          dataSource={async (c) => {
            return generateDropdownValues("city", c);
          }}
          defaultString="Select city"
          defaultSelected={
            searchForm.getField("city") !== ""
              ? [searchForm.getField("city")]
              : []
          }
          labelBaseProps={{
            label: "City",
            labelBaseClasses: {
              font: "text-xs font-medium leading-6 ",
            },
          }}
          pickerSelectSimpleClasses={{
            selectedDataClasses: {
              placeholderClasses: "font-normal text-xs text-gray-400",
              spanBaseClasses: "text-xs font-normal leading-2",
            },
            optionClasses: {
              label: "text-small bg-blue-200",
            },
          }}
          onChange={(value: any) => handleCityOnChange(value)}
          valueKey="value"
          multiple={false}
          enableClear={false}
          enableClose={false}
          enableSearch={true}
          disabled={searchForm.value.state ? false : true}
        />
      </div>

      <div
        className={`${fieldWrapperClass} flex w-64 lg:w-24 justify-center mt-4 lg:mt-0`}
        id="child_div"
      >
        <ButtonBase
          label="Search"
          buttonPrefix={
            <div className="mr-1">
              <SearchSvg />
            </div>
          }
          buttonBaseClasses={{
            padding: "px-4 py-2.5",
            width: "w-full lg:w-[initial]",
          }}
          onClick={() => handleSubmit()}
        />
      </div>
      <SearchModal
        open={open}
        closeCallback={() => setOpen(false)}
        content={
          <AdvanceSearchComponent
            propertiesFacetsWithoutFilter={props.propertiesFacetsWithoutFilter}
            router={router}
            searchForm={searchForm}
            urlData={props.urlData}
            onAction={() => setOpen(false)}
            {...searchForm.value}
          />
        }
      />
    </div>
  ) : (
    <div className="flex justify-center items-center w-full">
      <div className="animate-pulse w-1/4 mr-4">
        <div className="bg-gray-400 animate-pulse h-4 w-1/4 mb-2"></div>
        <div className=" mb-4 h-6 animate-pulse bg-gray-500"></div>
      </div>
      <div className="animate-pulse w-1/4 mr-4">
        <div className="bg-gray-400 animate-pulse h-4 w-1/4 mb-2"></div>
        <div className=" mb-4 h-6 animate-pulse bg-gray-500"></div>
      </div>
      <div className="animate-pulse w-1/4">
        <div className="bg-gray-400 animate-pulse h-4 w-1/4 mb-2"></div>
        <div className=" mb-4 h-6 animate-pulse bg-gray-500"></div>
      </div>
    </div>
  );
}
